<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-4xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-hidden"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
          <div class="w-full flex">
            <div
              class="pb-2 text-lg text-gray-900 tracking-wider font-semibold"
            >Los siguientes eventos estan registrados en la misma fecha y horario:</div>
          </div>
          <div class="flex h-64 items-center">
            <div class="w-1/2 mr-2 h-full overflow-auto">
              <div
                v-for="(event, index) in events"
                :key="event.evento_id"
                class="mb-2 px-4 py-2 text-center text-white font-bold tracking-widest"
                :style="'background-color:#'+colors[index]"
              >
                <div>{{ event.nombre_evento }}</div>
                <div>Inicio: {{ event.fecha | moment('DD/MM/YYYY') }} &ndash; {{ event.hora }}</div>
                <div>Fin: {{ event.fecha_final | moment('DD/MM/YYYY') }} &ndash; {{ event.hora_final }}</div>
              </div>
            </div>
            <div class="w-1/2 h-64">
              <l-map
              ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="11"
                :center="center"
                :options="{zoomControl: false}"
                @ready="onMapReady"
              >
                <l-geo-json :geojson="polygon" :options-style="geoStyle" />
                <template v-for="(event, index) in events">
                  <l-marker
                    :key="index"
                    :lat-lng="[event.lat, event.lng]"
                    :icon="createMarker(colors[index])"
                  ></l-marker>
                </template>
              </l-map>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import * as palette from "google-palette";
//import polygon from "../assets/polygonChapp.json";

import L from "leaflet";
import { LMap, LMarker, LGeoJson } from "vue2-leaflet";
import * as esri from "esri-leaflet";

import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  name: "duplicate-events-modal",
  data() {
    return {
      colors: [],
      polygon: polygon,
      zoom: 13,
      center: [19.412257, -99.200871],
      geoStyle: {
        color: "#7F7FFF",
        fill: false
      }
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    events: {
      required: true
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  methods: {
    close() {
      this.$emit("close", "dismiss");
    },
    onMapReady: function() {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        esri.basemapLayer("Topographic").addTo(map);

        this.colors = palette("mpn65", this.events.length);
      });
    },
    createMarker(color) {
      let iconSettings = {
        mapIconUrl:
          '<svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="{mapIconColor}" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>',
        mapIconColor: "#" + color,
        mapIconColorInnerCircle: "#fff",
        pinInnerCircleRadius: 12
      };

      let divIcon = L.divIcon({
        className: "leaflet-data-marker",
        html: L.Util.template(iconSettings.mapIconUrl, iconSettings),
        iconAnchor: [12, 32],
        iconSize: [25, 30],
        popupAnchor: [0, -28]
      });
      return divIcon;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>